import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_get_order_by_orderIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number }): 
  Promise<{ result: { Id?: number, BillingAddresId?: number, LookupCode?: string, OrderStatusId?: number, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, OrderClass?: { Id?: number, OrderClassTypeId?: number, OrderTypeId?: number }, ShipmentOrderLookups?: { CreatedSysDateTime?: string, Shipment?: { Id?: number, ActualWarehouseId?: number, ExpectedWarehouseId?: number, LookupCode?: string, StatusId?: number } }[], Account?: { Id?: number, Active?: boolean, AllocationPriority?: number, AllowReceiving?: boolean, AllowReturnsIn?: boolean, AllowShipping?: boolean, EnterpriseId?: number, LookupCode?: string, Name?: string, RequiresReceivingRma?: boolean, RequiresShippingRma?: boolean, TaxScheduleId?: number, TypeId?: number } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_order_by_orderId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
